import { create } from "zustand";

interface LostWebGLState {
  lostCharts: Set<string>;
  addLostChart: (id: string) => void;
}

const useWebGLLostStore = create<LostWebGLState>(set => ({
  lostCharts: new Set(),

  addLostChart: id =>
    set(state => ({
      lostCharts: new Set([...state.lostCharts, id]),
    })),
}));

export default useWebGLLostStore;
